export default __webpack_public_path__ + "44734705840745c70f5563d64a5b1061.svg";